import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import Treeselect from '@riophae/vue-treeselect';
import TripServices from '../../../services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker'
import CONSTANT from '../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import createrequestedroute from '../createrequestedroute';
import Util from '../../../../shared/util/util'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import XLSX from 'xlsx';
import ClientService from '../../../../clientmanagement/services/clientmanagement.service';
const moment = require('moment');

export default{
  name: 'serviceareatemplate',
  components: {
    Validator,
	Multiselect,
	Pagination,
	createrequestedroute,
    Loader,
    CustomExpandableTable,
    Treeselect,
    TripServices,
    VueElementLoading,
    DatePicker,

  },
  data: function() {
    return {
        isLoading:false,
        AWB:"",
        tableArr:[],
		Clientlist:[],
		companyNamelist: [],
		AssignedList: [],
        AssignedSR: null,
        companyName: null,
        shortcuts:false,
        daterange:"",
		status:null,
		tableColumn: ['Route ID','Route Name', 'Clients', 'FM Pincodes', 'LM Pincodes', 'Branch Name','Created by','Status','Action'],
		innerTableColumn: [],
		tableItems: [],
		currentPage: 1,
		totalPage: 0,
		totalCount:0,
		offset:0,
		pageLimit:CONSTANT.PER_PAGE_DATA,
		defaultHubID:"",
		shortcuts:false,
        daterange:"",
        Statuslist:[
            { id:'1', label:'Active'},
            { id:'0', label:'Inactive'}
        ],
		createdby:null,
        Createdbylist:[],
		pincode:'',
		showCreateroute: false,
		routeid:'',
		routename:'',
		sr:'',
		clients:'',
		statusevent:'',
		hubnamelist:[],
		selectedHub:{value:'',text:''},
        hubname:'',
		HubName: '',
		clientname:'',
		fmpincode:'',
		lmpincode:'',
		branchname:'',
		routestatus:'',
		selectedReqRouteObj: [],
		createdbyview:"",
		routeidview:"",
        showClients :false,
		clientsdata:[],
    }
  },

async mounted() {
	var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
	this.HubName = userdetail.currentHubName;
    this.userName = userdetail.email;
    this.defaultHubID = userdetail.hubID[0];
    this.userRoleFlag = (userdetail.rolename[0] == "Admin" || userdetail.rolename[0] == "Cargo Controlling Tower") ? 1:2;
	this.getCompanyShortName();
	this.getSRListing();
	this.getcreatedbylist();
	this.getRoutedata();
	this.getHubList();
},
methods: {
	isIntegerOnly: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode < 48 || charCode > 57) {
          evt.preventDefault();;
        } else {
          return true;
        }
    },
	showCreateRequested(){
		this.selectedReqRouteObj = {};
		this.selectedReqRouteObj.action = 'create'
		this.showCreateroute = true;
	},
	callParent() {
		this.showCreateroute = false;
		this.selectedReqRouteObj = null;
		//this.currentPage = this.page;
		this.offset = 0;
		this.getRoutedata();
	},
	async getCompanyShortName(){
		try {
		  let InputPayload = {};
		  var CompanyShortList = [];
		  let result = await ClientService.GetClientListByActiveContracts(InputPayload)
		  CompanyShortList = result.data.data.rows;
		  for (var i = 0; i < CompanyShortList.length; i++) {
			this.companyNamelist.push({
				'id': CompanyShortList[i].clientid,
				'label': CompanyShortList[i].clientshortname,
				'CompanyName': CompanyShortList[i].clientcompanyname,
				'ClientBusinessAccountId':CompanyShortList[i].clientbusinessaccountid
			})
		  }
		} catch(err){
		  console.log(err);
		}
	},
	async getSRListing() {
        try {
          let InputPayload = {
            HubId: [this.defaultHubID]
          };
          let result = await TripServices.getSRList(InputPayload);
		  let SRList = result.data.data;
          for (var i = 0; i < SRList.length; i++) {
            this.AssignedList.push({
              'id': SRList[i].userid,
              'label': SRList[i].srname + ' - '+ SRList[i].emptype +" " + '('+ SRList[i].userid + ')',
              'sremail': SRList[i].email
            });
          }
        } catch (err) {
          console.log(err);
        }
    },
    async getHubList(){
        try{
          let input = {}
		  let tempArr = [];
		  if( this.userRoleFlag ==1){
			let result = await  TripServices.GetHublist(input);
			let HubList = result.data.data.data;
			for (var i = 0; i < HubList.length; i++) {
			  tempArr.push({
			    'value': HubList[i].HubID,
			     'text': HubList[i].HubName
			  });
		    }
		  }else{
			tempArr.push({
				'value':this.defaultHubID,
				'text':this.userdetail.currentHubName
			})
		  }
		  this.hubnamelist = tempArr
        } catch(err){
         this.isLoading = false;
          console.log(err);
        }
      },
	selectHub(data){
		this.selectedHub = data;
        this.hubname = data.value;
	},
	async getcreatedbylist(){
		try {
		   var CreatedByList = [];
		  let result = await TripServices.getCreatedBylist()
		  if(result.data.code == 200){
			CreatedByList = result.data.data;
			for (var i = 0; i < CreatedByList.length; i++) {
			  this.Createdbylist.push({
				'id': CreatedByList[i].createdby,
				'label': CreatedByList[i].createdby,
			  })
		   }
		}
		} catch (err) {
		  console.log(err);
		}
	},
	resetFilter(){
		this.companyName = null
		this.routeid = ""
		this.createdby = null
		this.status =null
		this.pincode= ''
		this.hubname= ''
		this.getRoutedata();
   
	},
	searchRoute(){
		this.currentPage = 1;
		this.offset = 0;
		this.getRoutedata();
	},

	async getCustomTableEvent(event){
		if(event.actionType=="active"){
			this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
			this.activeAction(event);
		   }).catch((err)=>{
			 console.log(err)
		   });
		 }else if(event.actionType=="inactive"){
			this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
			this.activeAction(event);
		   }).catch((err)=>{
			 console.log(err)
		   })
		  }
	  if (event.actionType == "edit") {
        let selectedRouteObj = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedReqRouteObj = selectedRouteObj[0];
        this.selectedReqRouteObj.action = 'edit'
        this.showCreateroute = true;
      }else if(event.actionType == 'view'){
		this.isLoading = true
		let selectedRouteObj  = this.tableArr.filter(function(Items) {
			return Items.id == event.id;
		});
		
        this.routeidview = selectedRouteObj[0].id
		this.clientname = selectedRouteObj[0].clientname? selectedRouteObj[0].clientname :''
		this.createdbyview = selectedRouteObj[0].createdby
		this.fmpincode = selectedRouteObj[0].fm.toString()
		this.lmpincode = selectedRouteObj[0].lm.toString()
		this.branchname = selectedRouteObj[0].hubid
		this.routename = selectedRouteObj[0].routename
		this.routestatus = selectedRouteObj[0].status == 1 ? 'Active': 'Inactive'
		this.isLoading = false
	  }
		if (event.actionType == "viewClient") {
			let selectedRouteObj  = this.tableArr.filter(function(Items) {
				return Items.id == event.id;
			});
			this.clientsdata = selectedRouteObj[0];
			this.showClients = true;
		}
	},
	async activeAction(data){
        try {
          this.isLoading = true;
          var item = this.tableArr.find(item => item.id === data.id);
		  var isactivestatus = item.status == 0 ? 1 : 0
          let inputPayload = {
            "id": data.id,
            "status": isactivestatus
          }
		  let result = await TripServices.changeStatus(inputPayload)
          if(result.data.code == 200){
            if(result.data.data[0].status == 1){
              this.$alert("Route Inactivated  Successfully!!", `${item.routename}`, "success");
            }else{
              this.$alert("Route Activated Successfully!!", `${item.routename}`, "success");
            }
            this.getRoutedata();
            this.isLoading = false;
          }
        } catch(err){
          console.log(err);
        }
      },
	async getRoutedata(){
		try {
		  this.isLoading = true;
		  let inputPayload = {
			"offset": this.offset,
			"limit": this.pageLimit,
		  }
		//  let hubId = []
        //  hubId.push(this.defaultHubID)
        //  let input = {
        //    HubID:hubId
        //  }
        //  let result1 = await TripServices.GetHubDetailsForDamageMarking(input)
		//  console.log("Result 1 --",result1)
		//  inputPayload.hubid = this.defaultHubID
		  if(this.routeid){
			inputPayload.routeid = parseInt(this.routeid.trim());
		  }
		  if(this.pincode){
			inputPayload.pincode = parseInt(this.pincode.trim());
		  }
		  if(this.status){
			inputPayload.status = parseInt(this.status);
		  }
		  if(this.companyName){
			inputPayload.clientname = this.companyName.label;
			inputPayload.clientid = this.companyName.id;
			inputPayload.clientbusinessaccountid = this.companyName.id;
		  }
		  if(this.userRoleFlag == 2){
			inputPayload.hubid = this.defaultHubID;
		  }
		  if(this.hubname){
			inputPayload.hubid = this.hubname.value;
		  }
		  if(this.createdby){
			inputPayload.createdby = this.createdby;
		  }

		  let result = await TripServices.getRouteDetails(inputPayload)
		  let hubname = this.HubName
		  if(result.data.code == 200){
			this.tableArr = result.data.data.rows;
			this.totalCount = result.data.data.count;
			this.tableItems = result.data.data.rows.map((el)=>{
				let clientnamesarray = el.clientname.split(",");

			  return {
				'id': el.id,
				'Route ID': el.id,
				'Route Name':el.routename,
				'Clients':clientnamesarray.length>0 ? clientnamesarray : '',
				'FM Pincodes': (el.fm.toString()).split(","),
				'LM Pincodes': (el.lm.toString()).split(","),
				'Branch Name': el.hubname,
				'Created by': el.createdby,
				'Status':el.status
				}
			 })
		  }else{
			this.totalCount = 0
			this.tableItems = [];
		  }
		  if (this.totalCount < this.pageLimit) {
			this.totalPage = 1
		  } else {
			this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
		  }
		  this.isLoading = false;
		} catch(err){
		  console.log(err);
		  this.isLoading = false;
		}
	  },

	  async DownloadRequestedData(){
        try {
			this.isLoading = true;
			let inputPayload = {}
			// inputPayload.hubid = this.defaultHubID
		    if(this.routeid){
		   	  inputPayload.routeid = parseInt(this.routeid.trim());
			}
			if(this.pincode){
			  inputPayload.pincode = parseInt(this.pincode.trim());
			}
			if(this.status){
			  inputPayload.status = parseInt(this.status);
			}
			if(this.companyName){
			  inputPayload.clientname = this.companyName.label;
			  inputPayload.clientid = this.companyName.id;
			  inputPayload.clientbusinessaccountid = this.companyName.id;
			}
			if(this.userRoleFlag == 2){
				inputPayload.hubid = this.defaultHubID;
			}
			if(this.hubname){
			  inputPayload.hubid = this.hubname.value;
			}
			if(this.createdby){
			  inputPayload.createdby = this.createdby;
			}
			let result = await TripServices.getRouteDetails(inputPayload)
			if(result.data.code == 200){
			  let tempdata = result.data.data.rows.map((el)=>{
				return {
					'Route ID': el.id,
					'Route Name':el.routename,
					'Clients':el.clientname ? el.clientname : '',
					'FM Pincodes': el.fm,
					'LM Pincodes': el.lm,
					'Branch Name': el.hubname,
					'Created by': el.createdby,
					'Status':el.status ==1 ? 'Active': 'InActive'
				}
			  })
			  let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
			  const data = XLSX.utils.json_to_sheet(tempdata);
			  const wb = XLSX.utils.book_new();
			  XLSX.utils.book_append_sheet(wb, data, 'data')
			  XLSX.writeFile(wb,dt+'reuqestedrouteData.xlsx');
			}else{
			  this.isLoading = false;
			  this.$alertify.error("Something went wrong");
			  return false;
			}
			this.isLoading = false;
				
		} catch (error) {
			console.log("Error --",error);
			this.isLoading = false;
		}
	  },
   
	onPageChange(page) {
		this.currentPage = page;
		this.offset = (page - 1) * this.pageLimit
		this.getRoutedata();
	},
 },
}


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/Autoallocation/routelist/routelist.component.js